import React from "react"

function IconMouseEmitSignalSlash({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="mouse-emit-signal-slash"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-mouse-emit-signal-slash"
      {...props}
    >
      <path
        d="m6.3 9.05 1.282 1.2v2.113h2.254l1.396 1.309h-3.65v2.09a4.477 4.477 0 0 0 4.241 4.474l.222.005.22-.005a4.473 4.473 0 0 0 3.642-2.18l.973.91a5.793 5.793 0 0 1-4.327 2.563l-.243.016-.25.005a5.787 5.787 0 0 1-5.782-5.549l-.005-.238V9.338c0-.1.01-.196.028-.289zm10.064-1.195c.771 0 1.404.588 1.476 1.34l.007.143v5.75l-1.31-1.228v-.188h-.202l-1.396-1.31h1.598V9.339a.174.174 0 0 0-.118-.166l-.055-.008-3.65-.001v1.113L10.13 7.854h6.234zm-4.228-3.218a2.812 2.812 0 0 1 2.175 1.019.655.655 0 1 1-1.007.836 1.503 1.503 0 0 0-2.327.006.655.655 0 1 1-1.01-.833 2.813 2.813 0 0 1 2.17-1.028zm-.006-2.724a5.748 5.748 0 0 1 4.294 1.913.655.655 0 0 1-.973.876 4.437 4.437 0 0 0-6.628.016.655.655 0 0 1-.977-.872 5.746 5.746 0 0 1 4.284-1.933z"
        fill={color}
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
      <path
        d="M2.795 3.37a.655.655 0 0 1 .832-.102l.093.073 17.455 16.363a.655.655 0 0 1-.802 1.028l-.093-.073L2.825 4.296a.655.655 0 0 1-.03-.925z"
        fill={color2 || color}
        fillRule="nonzero"
        style={{ height: height || fontSize }}
        originalclass="__danger"
      />
    </svg>
  )
}

export default IconMouseEmitSignalSlash
